<template>
    <div v-if="model && model.recurrence" :class="container">
        <div :class="card">
            <h1 class="px-3 py-2 mb-0">
                <i class="mdi mdi-credit-card mr-3"></i>
                {{ $t('billing.recurrence.recurrence') }}
            </h1>
            <div class="d-flex flex-wrap">
                <div class="col-12 pt-3 bg-li">
                    <h3>{{ $t('billing.recurrence.info') }}</h3>
                </div>
                <div class="px-3 p-4 col-12">
                    <ul class="list-unstyled">
                        <li v-show="model.recurrence.recurring_payment">
                            <span class="font-weight-bolder">
                                # {{ $t('billing.recurrence.hash') }}:
                            </span>
                            <span>{{
                                model.recurrence.recurring_payment
                            }}</span>
                        </li>
                        <li v-show="model.recurrence.name">
                            <span class="font-weight-bolder">
                                {{ $t('billing.recurrence.name') }}:
                            </span>
                            <span>{{ model.recurrence.name }}</span>
                        </li>
                        <li v-show="model.recurrence.plan">
                            <span class="font-weight-bolder">
                                {{ $t('billing.recurrence.plan') }}:
                            </span>
                            <span>{{ model.recurrence.plan }}</span>
                        </li>
                        <li v-show="model.recurrence.value">
                            <span class="font-weight-bolder">
                                {{ $t('billing.recurrence.value') }}:
                            </span>
                            <span>{{
                                formatValue(
                                    model.recurrence.value,
                                    model.recurrence.currency
                                )
                            }}</span>
                        </li>
                        <li v-if="model.recurrence.cycle !== -1">
                            <span class="font-weight-bolder">
                                {{ $t('billing.recurrence.cicle') }}:
                            </span>
                            <span>{{ model.recurrence.cycle }}</span>
                        </li>
                        <li v-else>
                            <span class="font-weight-bolder">
                                {{ $t('billing.recurrence.subscription') }}:
                            </span>
                            <span class="recurrence-label">{{ model.recurrence.label }}</span>
                        </li>
                        <li>
                            <span class="font-weight-bolder">
                                {{ $t('billing.recurrence.status') }}:
                            </span>
                            <span>
                                {{ $t(`billing.recurrence.status_codes`)[model.recurrence.status] }}
                            </span>
                        </li>
                    </ul>
                </div>
                <!-- <div class="col-12 pt-3 bg-li">
                    <div v-if="linkAvailable" class="row">
                        <div class="col-8">
                            <h3>{{ $t('billing.recurrence.payment_type') }}</h3>
                            <div class="control ml-4 mb-2" v-if="gatewaysAvailable">
                                <div
                                    v-for="gate in model.gateways"
                                    :key="gate.id"
                                    class="custom-control custom-radio"
                                >
                                    <input
                                        type="radio"
                                        v-model="gateway"
                                        :value="gate"
                                        :id="gate.slug"
                                        :name="$t('cart.payment_type')"
                                        class="custom-control-input"
                                        v-validate="'required'"
                                    />
                                    <label
                                        class="custom-control-label"
                                        :for="gate.slug"
                                    >
                                        {{ gate.name }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <template v-if="gateway">
                                <h3>{{ $t('cart.currency') }}</h3>
                                <div class="control ml-4">
                                    <div
                                        v-for="code in gateway.currencies"
                                        :key="code"
                                        class="custom-control custom-radio"
                                    >
                                        <input
                                            type="radio"
                                            v-model="currency"
                                            :value="code"
                                            :id="code"
                                            :name="$t('cart.currency')"
                                            class="custom-control-input"
                                            v-validate="'required'"
                                        />
                                        <label
                                            class="custom-control-label"
                                            :for="code"
                                        >
                                            {{ code }}
                                        </label>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div class="col-12" v-if="!gatewaysAvailable">
                            <p class="p-2">
                                {{ $t('billing.recurrence.no_payment_available') }}
                            </p>
                        </div>
                    </div>
                    <p
                        v-show="model.recurrence.payment_method && model.recurrence.status != 2"
                        class="col-12 p-2"
                    >
                        {{ $t('billing.recurrence.linked_payment') }}
                        <strong>{{ model.recurrence.payment_method }}</strong>.
                    </p>
                    <p
                        v-show="!model.recurrence.payment_method && gatewaysAvailable"
                        class="col-12 p-2"
                    >
                        {{ $t('billing.recurrence.no_linked_payment') }}.
                    </p>
                </div> -->
                <!-- <div class="col-12">
                    <div class="d-flex justify-content-between pt-3 pb-3">
                        <a href="/app/financial" class="btn btn-warning">
                            {{$t('common.back')}}
                        </a>
                        <button
                            v-if="!linkAvailable"
                            @click="unLinkRecurrence"
                            :title="$t('billing.recurrence.unlink_payment')"
                            class="btn btn-dark"
                        >
                            {{ $t('billing.recurrence.unlink_payment') }}
                        </button>
                        <button
                            v-else-if="gatewaysAvailable"
                            @click="linkRecurrence"
                            :title="$t('billing.recurrence.link_payment')"
                            class="btn btn-success"
                        >
                            {{ $t('billing.recurrence.link_payment') }}
                        </button>
                    </div>
                </div> -->
            </div>
        </div>
        <div :class="card">
            <h2 class="px-3 py-2 mb-0 mt-3">
                <i class="mdi mdi-credit-card mr-3"></i>
                {{ $t('billing.recurrence.invoices') }}
            </h2>
            <table class="table table-hover table-condensed">
                <thead class="thead-light">
                    <tr>
                        <th>{{ $t('billing.invoice.descrition') }}</th>
                        <th></th>
                        <th>{{ $t('common.status') }}</th>
                        <th>{{ $t('common.value') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="invoice in model.invoices"
                        :key="invoice.id"
                    >
                        <td data-th="Product">
                            <a :href="`/app/financial/invoice/${invoice.id}`">
                                {{
                                    invoice.description
                                        ? invoice.description
                                        : invoice.name
                                }}
                            </a>
                        </td>
                        <td></td>
                        <td>
                            <i
                                :class="[
                                    statusInvoice(invoice.status).icon,
                                    statusInvoice(invoice.status).class,
                                ]"
                            ></i>
                            <span class="status">
                                {{statusInvoice(invoice.status).name}}
                            </span>
                        </td>
                        <td data-th="Price" class="budget">
                            {{ invoice.total }}
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="card-footer py-4 d-flex justify-content-between">
                <div class="d-flex align-items-center">
                    <span>{{ metaStatus }}</span>
                </div>
                <base-pagination
                    v-if="meta"
                    class="mb-0"
                    :page-count="meta.last_page"
                    v-model="meta.current_page"
                    @input="onChangePage"
                    type="#525F7F"
                ></base-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import Currency from '../mixins/currency';
import Invoice from '../mixins/invoice';

import BasePagination from '../argon/components/BasePagination';

export default {
    name: 'Recurence',
    components: {
        BasePagination,
    },
    props: {
        value: {
            type: Object,
        },
    },
    data() {
        return {
            meta: {
                last_page: 1,
                current_page: 1,
                to: 1,
                total: 1,
                from: 1,
            },
            gateway: null,
            column: '',
            order: '',
            filters: '',
            perPage: 5,
            model: this.value,
            currency: '',
        };
    },
    mixins: [Currency, Invoice],
    watch: {
        currency(code, oldVal) {
            if (code && code !== oldVal) {
                this.$loading.show();
                this.$store.dispatch('CHANGE_CURRENCY', {
                    code,
                });
                window.axios.get(
                    `/api/app/recurrences/${this.model.recurrence.id}/currency`,
                    {
                        params: {
                            code,
                        },
                    },
                ).then((res) => {
                    this.$loading.close();
                    if (res.data) {
                        this.model.recurrence.value =
                            res.data.recurrence.value;
                        this.model.recurrence.currency =
                            res.data.recurrence.currency;
                    }
                })
                    .catch(console.error)
                    .finally(() => this.$loading.close());
            }
        },
    },
    computed: {
        container() {
            if (this.$mq === 'sm' || this.$mq === 'md') {
                return 'container-fluid';
            }
            return 'container';
        },
        card() {
            if (this.$mq === 'sm') {
                return '';
            }
            return 'card nch--cart';
        },
        color() {
            return this.$store.getters.COLOR;
        },
        metaStatus() {
            return this.meta
                ? ` ${this.$t('common.showing')} ${this.meta.from || 0} ${this.$t('common.to')} ${this.meta.to || 0} ${this.$t('common.of')} ${this.meta.total} ${this.$t('common.results')}`
                : '';
        },
        gatewaysAvailable() {
            return this.model.gateways.length > 0;
        },
        linkAvailable() {
            const {
                payment_method: paymentMethod,
                status,
            } = this.model.recurrence;
            return (!paymentMethod || (paymentMethod && status === 2));
        },
    },
    methods: {
        getInvoices() {
            this.$loading.show();
            window.axios
                .get(
                    `/api/app/recurrences/${this.model.recurrence.id}/invoices/${this.perPage}`,
                    {
                        params: {
                            page: this.meta ? this.meta.current_page : 1,
                            column: this.column,
                            order: this.order,
                            filters: this.filters,
                        },
                    },
                ).then((res) => {
                    this.model.invoices = res.data.data;
                    this.meta = res.data.meta;
                })
                .catch(console.error)
                .finally(() => this.$loading.close());
        },
        unLinkRecurrence() {
            this.$loading.show();
            window.axios
                .post(
                    `/api/app/recurrences/${this.model.recurrence.id}/disassociate/gateway`,
                )
                .then((res) => {
                    this.$notify({
                        type: 'success',
                        message: res.data.message,
                    });
                    this.model.recurrence = res.data.recurrence;
                })
                .catch(console.error)
                .finally(() => this.$loading.close());
        },
        linkRecurrence() {
            try {
                this.$loading.show();
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        window.axios
                            .post(
                                `/api/app/recurrences/${this.model.recurrence.id}/associate/gateway`,
                                {
                                    id: this.model.recurrence.id,
                                    slug: this.gateway.slug,
                                },
                            ).then((res) => {
                                location.href = res.data.url;
                            }).catch(() => {
                                this.$loading.close();
                            });
                        return;
                    }
                    const payment = this.errors.first(this.$t('cart.payment_type'));
                    const currency = this.errors.first(this.$t('cart.currency'));
                    if (payment) {
                        this.$notify({
                            type: 'danger',
                            message: payment,
                        });
                    }
                    if (currency) {
                        this.$notify({
                            type: 'danger',
                            message: currency,
                        });
                    }
                    this.$loading.close();
                });
            } catch (e) {
                console.error(e.message);
            }
        },
        onChangePage(page) {
            this.meta.current_page = page;
            this.getInvoices();
        },
    },
    mounted() {
        this.getInvoices();
    },
};
</script>

<style>
.bg-li {
    background: #f6f9fc;
    border: 1px solid #e9ecef;
}

.nch--cart {
    width: 90%;
    margin: auto;
    margin-top: 40px;
    margin-bottom: 40px;
}
.recurrence-label{
    text-transform: capitalize;
}
</style>
